import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Button,
  Modal,
  Form,
  Col,
  Table,
  Spin,
  Select,
  Divider,
  Tag,
} from "antd";

import { CheckCircleOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { rightAction } from "../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Vault's Branch ",
    dataIndex: "vaultId",
    // dataIndex: "vaultsbranch",
  },
  {
    title: "Till Name",
    dataIndex: "description",
    // dataIndex: "tillName",
  },

  {
    title: "Denom. Tracking",
    dataIndex: "allowDenomTracking",
    // dataIndex: "denomTracking",
  },
  {
    title: "Print Receipt",
    dataIndex: "printTransactionReceipt",
    // dataIndex: "printReceipt",
  },
  {
    title: "Allow Reversal",
    dataIndex: "allowTransactionReversal",
    // dataIndex: "allowReversal",
  },
];

const ManageTillConfiguration = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [codeList, setCodeList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    getCodeList();
    BOM.HasPermission("CREATE_TELLER_CONFIG_TELLER_OPERATION") &&
      rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getCodeList = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.Tellerconfig, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        console.log(res);
        let tempCodeList = [];
        objList.forEach((element) => {
          tempCodeList.push({
            key: element?.id,
            id: element?.id,
            vaultId: element?.vaultId.operationId2.officeId.name,
            description: element?.description,
            allowDenomTracking: element?.allowDenomTracking
              ? "Enabled"
              : "Disabled",
            printTransactionReceipt: element?.printTransactionReceipt
              ? "Enabled"
              : "Disabled",
            allowTransactionReversal: element?.allowTransactionReversal
              ? "Enabled"
              : "Disabled",
          });
        });

        console.log(res);

        setCodeList(tempCodeList);
        setOriginalList(tempCodeList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  //DECLARED METHODS

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);

    dispatch({
      type: cnt.RIGHT_DETAIL_BTN,
    });

    if (BOM.HasPermission("UPDATE_TELLER_CONFIG_TELLER_OPERATION")) {
      dispatch({
        type: cnt.RIGHT_EDIT_BTN,
      });
    }
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setCodeList(originalList);
      return;
    }
    const filterBySearch = originalList.filter((item) =>
      item?.codeName?.toLowerCase().includes(searchKey?.toLowerCase()),
    );
    setCodeList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-sya0600", { state: { id: selectedRow.id } });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-sya0600", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-sya0600", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const handleOnDelete = () => {
    let action = "Delete  ";
    let name = `${selectedRow.codeName}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + name,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Codes}/${selectedRow.key}`;
        let body = {
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCodeMsg);
            // navigate("/manage-paymen");
            getCodeList();
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      },
    );
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
      // onDelete={handleOnDelete}
    >
      <TopContent
        pageTitle={labelConfig.manageTillConfiguration}
        pageItems={staticConfig.manageTillConfigurationItems}
      />

      <Card
        title={`${labelConfig.till} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search Till by branch"
                style={{
                  width: 400,
                }}
                allowClear
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={codeList}
              columns={columns}
              fileName={"Till List"}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={codeList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageTillConfiguration);
